import styled from 'styled-components';

export const GoSafeZone = styled.div`
  border-radius: 0.4rem;
  background: white;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 2rem;
  width: 100%;
  margin-bottom:1rem;
  button {
    outline: 0;
    border: 0;
    background: white;
    color: #2276e3;
    font-size: 1.6rem;
    cursor: pointer;
  }
`;
export const Info = styled.span`
  font-size: 1.6rem;
  padding-left: 1rem;
`;
export const Content = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;
